import { AbstractControl } from "@angular/forms";

export function PasswordNoUppercaseValidator(control: AbstractControl): { passwordNoUppercase: boolean} | null {
  const newPassword = control.value;

  let atLeast1UpperCharacter = false;
  for (let i = 0; i < newPassword.length; i++) {
    if (
      newPassword[i] === newPassword[i].toUpperCase() &&
      newPassword[i] !== newPassword[i].toLowerCase()
    ) {
      atLeast1UpperCharacter = true;
    }
  }

  if (!atLeast1UpperCharacter) {
    return { passwordNoUppercase: true };
  }

  return null;
}
